// extracted by mini-css-extract-plugin
export default {"center-justified":"MyCode_center-justified__2tdw3","center-image":"MyCode_center-image__2GpRL","bold":"MyCode_bold__5rs-i"};